import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react"
import MetaTags from 'react-meta-tags';
import { Link, withRouter } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Alert,
  Spinner
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";

import {
  syncArchivio
} from "store/archivio/actions";

//redux
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import CustomSearch from "components/Heytech/CustomSearch";

import { size } from "lodash";

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { formatRelative, differenceInDays, format } from 'date-fns'
import { it } from 'date-fns/locale';
import { useHistory } from "react-router-dom";
import uuid from 'react-uuid';

import SyncOfflineOrderBtn from "./../../components/Heytech/SyncOfflineOrderBtn"

import { getCachedArchivio, loadArchivio, labelTipo, tipoFromProposta } from "helpers/archivio_store";

// Testo su cui cercare, calcolato una sola volta per record
const searchTextCache = new WeakMap();
const getSearchText = item => {
  let text = searchTextCache.get(item);
  if (text === undefined) {
    const cliente = (item.json && item.json.cliente) || {};
    text = [
      JSON.stringify(item.tags),
      cliente.anagrafica_descrizione,
      cliente.anagrafica_codice,
      cliente.anagrafica_email,
      item.code,
      item.json && (item.json.proposta === 1 ? "proposta d'ordine" : "offerta"),
      item.json && item.json.type,
      item.json && JSON.stringify(item.json.order),
    ].filter(v => v !== null && v !== undefined && v !== "").join("\u0001").toLowerCase();
    searchTextCache.set(item, text);
  }
  return text;
};

const Archivio = props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const tipo = props.match.params.tipo;
  const searchKey = "archiveSearch_" + tipo;
  const pageKey = "archivePage_" + tipo;
  const syncState = useSelector(state => state.archivio[tipo]);
  const [listArchivio, setListArchivio] = React.useState([]);
  const [listArchivioOriginal, setListArchivioOriginal] = React.useState(getCachedArchivio(tipo) || false);
  const [searchField, setSearchField] = React.useState(localStorage.getItem(searchKey) ? localStorage.getItem(searchKey) : "");
  const [isOnline, setIsOnline] = React.useState(navigator.onLine);

  const localArchivio = (localStorage.getItem("ht-save-offline") ? JSON.parse(localStorage.getItem("ht-save-offline")) : [])
    .filter(item => item.data && tipoFromProposta(item.data.proposta) === tipo);

  // All'apertura e al ritorno della connessione: sincronizza (delta, o completo se serve).
  // Offline il saga non scarica nulla, legge solo la data dell'ultimo aggiornamento.
  useEffect(() => {
    dispatch(syncArchivio(tipo));
    const onOnline = () => {
      setIsOnline(true);
      dispatch(syncArchivio(tipo));
    };
    const onOffline = () => setIsOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, [tipo]);

  // Rilegge i record dalla cache ogni volta che cambiano (pagine scaricate, delta, modifiche locali)
  useEffect(() => {
    let active = true;
    loadArchivio(tipo).then(records => {
      if (active && records) setListArchivioOriginal(records);
    });
    return () => { active = false; };
  }, [tipo, syncState.version]);

  useEffect(() => {
    if (!listArchivioOriginal) return;
    const timeout = window.setTimeout(() => handleSearch(searchField), searchField === "" ? 0 : 250);
    return () => window.clearTimeout(timeout);
  }, [listArchivioOriginal, searchField]);

  const getCapitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  const getStringDate = (date) => {
    return Math.abs(differenceInDays(new Date(date.replace(/-/g, "/")), new Date())) < 6
      ? getCapitalize(formatRelative(new Date(date.replace(/-/g, "/")), new Date(), { locale: it }))
      : getCapitalize(new Date(date.replace(/-/g, "/")).toLocaleString('it-IT', { dateStyle: 'full', timeStyle: 'short' }));
  }

  const { SearchBar } = Search;
  const sizePerPage = 20;
  const pageOptionsLocal = {
    sizePerPage: sizePerPage,
    totalSize: size(listArchivio), // replace later with size(users),
    custom: false,
    hideSizePerPage: true,
    showTotal: true
  };
  const pageOptions = {
    sizePerPage: sizePerPage,
    totalSize: size(listArchivio), // replace later with size(users),
    custom: false,
    hideSizePerPage: true,
    showTotal: true,
    page: localStorage.getItem(pageKey) ? parseInt(localStorage.getItem(pageKey)) : 1,
    onPageChange: (e) => { localStorage.setItem(pageKey, e) },
  };
  const defaultSorted = [
    {
      dataField: "data", // if dataField is not match to any column you defined, it will be ignored.
      order: "desc", // desc or asc
    },
  ];

  const tableRowEvents = {
    onClick: (e, row, rowIndex) => {
      if (!e.target.classList.contains('bx-exclude') && !e.target.classList.contains('btn-light')) {
        history.push("/archivio/" + tipo + "/dettaglio/" + row.id);
      }
    }
  }

  const tableRowLocalEvents = {
    onClick: (e, row, rowIndex) => {
      if (!e.target.classList.contains('bx-exclude') && !e.target.classList.contains('btn-light')) {
        localStorage.setItem("ht-dettaglio-local-archivio", JSON.stringify(row));
        history.push("/archivio/" + tipo + "/dettaglio-local/" + row.offlineId);
      }
    }
  }

  const changePageEvent = {
    onChange: (e, page, size) => {
      console.log(page);
    }
  }

  const archivioColumns = [
    {
      text: "Tipologia",
      dataField: "prefisso",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          <h5 className="font-size-14 mb-1 text-dark">
            {order.json.proposta === 1 ? "Proposta d'ordine" : "Offerta"}{" "}{order.json.type}
            {order.trasformato_da !== null && <Badge pill className="badge-primary ms-1">
              Creato da offerta
            </Badge>}
            {order.trasformato_in !== null && <Badge pill className="badge-primary ms-1">
              Trasformato in ordine
            </Badge>}
          </h5>
          {order.is_draft == 1 && <Badge pill className="badge-secondary ms-1">Bozza</Badge>}
        </>
      ),
    },
    {
      text: "Cliente",
      dataField: "json.cliente.anagrafica_descrizione",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          <h5 className="font-size-14 mb-1 text-dark">
            {order.json.cliente.anagrafica_descrizione}
          </h5>
          <p className="text-muted mb-0">{order.json.cliente.anagrafica_codice}</p>
        </>
      ),
    },
    {
      text: "Tag",
      dataField: "tags",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          {order.tags.map((item, key) => { return key === 0 ? item : ", " + item })}
        </>
      ),
    },
    {
      text: "Codice",
      dataField: "code",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          {order.code.indexOf(".") > 0 ? order.code.substring(0, order.code.indexOf(".")) : order.code}
        </>
      ),
    },
    {
      text: "Data",
      dataField: "data",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          {getStringDate(order.data)}
        </>
      ),
    },
    /* {
      text: "Azioni",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          <Dropdown
            isOpen={order.id === openAction}
            direction="left"
            className="dropstart"
            toggle={() => setOpenAction(order.id === openAction ? false : order.id)}
          >
            <DropdownToggle tag="button" className="btn btn-light">
              <i className="bx bx-exclude" />
            </DropdownToggle>
            <DropdownMenu>
              {order.json.proposta === 0 && !order.is_draft && <DropdownItem><i className="bx bxs-file-pdf font-size-16 align-middle me-2"></i> Visualizza PDF</DropdownItem>}
              <DropdownItem><i className="bx bx-duplicate font-size-16 align-middle me-2"></i> Duplica</DropdownItem>
              <DropdownItem><i className="bx bx-edit font-size-16 align-middle me-2"></i> Modifica</DropdownItem>
              {order.json.proposta === 0 && !order.is_draft && <DropdownItem><i className="bx bx-check-circle font-size-16 align-middle me-2"></i> Trasforma in Ordine</DropdownItem>}
              <DropdownItem><i className="bx bx-trash-alt font-size-16 align-middle me-2"></i> Elimina</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </>
      ),
    }, */
  ];

  const archivioOfflineColumns = [
    {
      text: "Tipologia",
      dataField: "prefisso",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          <h5 className="font-size-14 mb-1 text-dark">
            {order.data.proposta === 1 ? "Proposta d'ordine" : "Offerta"}{" "}{order.data.type}
          </h5>
          {order.offLineStatus == "Bozza" && <Badge pill className="badge-secondary ms-1">Bozza</Badge>}
        </>
      ),
    },
    {
      text: "Cliente",
      dataField: "data.cliente.anagrafica_descrizione",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          <h5 className="font-size-14 mb-1 text-dark">
            {order.data.cliente.anagrafica_descrizione}
          </h5>
          <p className="text-muted mb-0">{order.data.cliente.anagrafica_codice}</p>
        </>
      ),
    },
    {
      text: "Tag",
      dataField: "tags",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          {order.tags && order.tags.map((item, key) => { return key === 0 ? item : ", " + item })}
        </>
      ),
    },
    {
      text: "Data",
      dataField: "data",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          {getStringDate(order.offlineId)}
        </>
      ),
    },
    /* {
      text: "Azioni",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          <Dropdown
            isOpen={order.id === openAction}
            direction="left"
            className="dropstart"
            toggle={() => setOpenAction(order.id === openAction ? false : order.id)}
          >
            <DropdownToggle tag="button" className="btn btn-light">
              <i className="bx bx-exclude" />
            </DropdownToggle>
            <DropdownMenu>
              {order.json.proposta === 0 && !order.is_draft && <DropdownItem><i className="bx bxs-file-pdf font-size-16 align-middle me-2"></i> Visualizza PDF</DropdownItem>}
              <DropdownItem><i className="bx bx-duplicate font-size-16 align-middle me-2"></i> Duplica</DropdownItem>
              <DropdownItem><i className="bx bx-edit font-size-16 align-middle me-2"></i> Modifica</DropdownItem>
              {order.json.proposta === 0 && !order.is_draft && <DropdownItem><i className="bx bx-check-circle font-size-16 align-middle me-2"></i> Trasforma in Ordine</DropdownItem>}
              <DropdownItem><i className="bx bx-trash-alt font-size-16 align-middle me-2"></i> Elimina</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </>
      ),
    }, */
  ];

  var node = useRef();

  const keyField = "id";

  const handleSearch = (searchQuery) => {
    localStorage.setItem(searchKey, searchQuery);
    const words = searchQuery.toLowerCase().split(" ").filter(w => w !== "");
    if (words.length === 0) {
      setListArchivio(listArchivioOriginal);
      return;
    }
    setListArchivio(listArchivioOriginal.filter(item => {
      const text = getSearchText(item);
      return words.every(w => text.indexOf(w) !== -1);
    }));
  }

  const formatTs = ts => ts ? new Date(ts * 1000).toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'short' }) : "mai";

  const statusBadge = !isOnline
    ? <Badge pill color="secondary" className="ms-1" style={{ padding: "1em" }}>Offline · aggiornato al {formatTs(syncState.lastSync)}</Badge>
    : (syncState.status === "loading"
      ? <Badge pill color="warning" className="ms-1" style={{ padding: "1em" }}>Archivio in aggiornamento{syncState.count > 0 ? " (" + syncState.count + ")" : ""}</Badge>
      : (syncState.status === "ok"
        ? <Badge pill color="success" className="ms-1" style={{ padding: "1em" }}>Archivio aggiornato</Badge>
        : <Badge pill color="danger" className="ms-1" style={{ padding: "1em" }}>Archivio non aggiornato</Badge>));

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Archivio {labelTipo(tipo)} | Gruppo Bisaro Cloud</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Attività" breadcrumbItem={"Archivio " + labelTipo(tipo)} />
          {localArchivio.length > 0 && <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <h3>Archivio in locale</h3>
                  <Alert color="danger">
                    Dati non sincronizzati. {" "}
                    <SyncOfflineOrderBtn element={<div className="alert-link btn btn-danger" style={{ "color": "white", "fontWeight": "normal" }}>
                      Sincronizza ora
                    </div>} />
                    {!navigator.onLine && "Connettiti ad internet per sincronizzare i dati."}
                  </Alert>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptionsLocal)}
                    keyField={keyField}
                    columns={archivioOfflineColumns}
                    data={localArchivio}
                    dataSize={localArchivio.length}
                  >
                    {({ paginationProps, paginationTableProps }) => {
                      return (
                        <ToolkitProvider
                          keyField={keyField}
                          data={localArchivio}
                          columns={archivioOfflineColumns}
                          bootstrap4
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <div className="product_list_heder d-flex justify-content-between align-middle mb-3">
                                <div></div>
                                <div className="d-flex align-items-center">{statusBadge}</div>
                              </div>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      keyField={keyField}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap table-hover"
                                      }
                                      bordered={false}
                                      striped={false}
                                      responsive
                                      ref={node}
                                      rowEvents={tableRowLocalEvents}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      );
                    }}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>}
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {!listArchivioOriginal ? (!isOnline ? <h4 style={{ "textAlign": "center" }}>Archivio non ancora scaricato: connettiti ad internet per scaricarlo</h4> : (syncState.status === "error" ? <h4 style={{ "textAlign": "center" }}>Errore nello scaricamento dell&apos;archivio</h4> : <div style={{ "textAlign": "center" }}><Spinner>
                    Loading...
                  </Spinner></div>)) : <>
                    {localArchivio.length > 0 && <>
                      <h3>Archivio in cloud</h3><br /></>}
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField={keyField}
                      columns={archivioColumns}
                      data={listArchivio}
                      dataSize={listArchivio.length}
                    >
                      {({ paginationProps, paginationTableProps }) => {
                        return (
                          <ToolkitProvider
                            keyField={keyField}
                            data={listArchivio}
                            columns={archivioColumns}
                            bootstrap4
                          >
                            {toolkitProps => (
                              <React.Fragment>
                                <div className="product_list_heder d-flex justify-content-between align-middle mb-3">
                                  <>
                                    <div className="search-box ms-2 mb-2 d-inline-block">
                                      <div className="position-relative">
                                        <CustomSearch value={searchField} placeholder="Ricerca" onChange={(e) => {
                                          setSearchField(e.currentTarget.value);
                                        }} />
                                      </div>
                                    </div>
                                  </>
                                  <div className="d-flex align-items-center">{statusBadge}</div>
                                </div>
                                <Row>
                                  <Col xl="12">
                                    <div className="table-responsive">
                                      <BootstrapTable
                                        keyField={keyField}
                                        {...toolkitProps.baseProps}
                                        {...paginationTableProps}
                                        defaultSorted={defaultSorted}
                                        classes={
                                          "table align-middle table-nowrap table-hover"
                                        }
                                        bordered={false}
                                        striped={false}
                                        responsive
                                        ref={node}
                                        rowEvents={tableRowEvents}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        );
                      }}
                    </PaginationProvider></>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Archivio.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
  t: PropTypes.any
}

export default withRouter(withTranslation()(Archivio));